import {
  CANONICAL_ORIGIN,
  DEFAULT_TITLE,
  SITE_NAME
} from "./chunk-AFR26THN.mjs";

// src/types/seo/seoText.ts
var META_DESCRIPTION_MAX_LENGTH = 155;
var formatPageTitle = (title) => {
  const trimmed = title?.trim();
  return trimmed ? `${trimmed} | ${SITE_NAME}` : DEFAULT_TITLE;
};
var toPlainText = (text) => text.replace(/<[^>]*>/g, " ").replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1").replace(/\[([^\]]*)\]\([^)]*\)/g, "$1").replace(/[*_#>`~|<]/g, " ").replace(/\s+/g, " ").trim();
var toMetaDescription = (text, max = META_DESCRIPTION_MAX_LENGTH) => {
  const plain = toPlainText(text);
  if (plain.length <= max) return plain;
  const cut = plain.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  const atWord = lastSpace > 0 ? cut.slice(0, lastSpace) : cut;
  return `${atWord.replace(/[\s.,;:!?\-–—]+$/, "")}\u2026`;
};
var canonicalUrl = (pathname) => {
  const path = pathname.split(/[?#]/)[0].replace(/\/{2,}/g, "/");
  const withLead = path.startsWith("/") ? path : `/${path}`;
  const normalised = withLead.length > 1 ? withLead.replace(/\/+$/, "") : withLead;
  return `${CANONICAL_ORIGIN}${normalised || "/"}`;
};
var absoluteUrl = (url) => url.startsWith("/") && !url.startsWith("//") ? `${CANONICAL_ORIGIN}${url}` : url;
var pickSrcsetCandidate = (srcset, targetWidth = 1200) => {
  if (!srcset) return void 0;
  const candidates = srcset.split(/,\s+/).map((entry) => {
    const [url, descriptor] = entry.trim().split(/\s+/);
    const width = descriptor?.endsWith("w") ? Number(descriptor.slice(0, -1)) : NaN;
    return { url, width };
  }).filter((c) => c.url && Number.isFinite(c.width)).sort((a, b) => a.width - b.width);
  if (candidates.length === 0) return void 0;
  return (candidates.find((c) => c.width >= targetWidth) ?? candidates[candidates.length - 1]).url;
};

export {
  META_DESCRIPTION_MAX_LENGTH,
  formatPageTitle,
  toPlainText,
  toMetaDescription,
  canonicalUrl,
  absoluteUrl,
  pickSrcsetCandidate
};
